import { navigateTo, useApi } from "#imports";
import { ROUTE_WEBPLANNER_APPOINTMENTS } from "~/constants/routes";
import { getOAuthUser } from "~/utils/oauthUserStorage";

export default defineNuxtRouteMiddleware(async (to) => {
  const patientId = to.params.patientId;

  if (!patientId || Array.isArray(patientId)) {
    return;
  }

  if (!getOAuthUser()) {
    return;
  }

  try {
    const api = await useApi();
    const response = await api.patient(Number(patientId));

    if (response.data.is_webplanner_placeholder) {
      return navigateTo(ROUTE_WEBPLANNER_APPOINTMENTS);
    }
  } catch {}
});
